var swiper = new Swiper(".home-swiper-container", {
  slidesPerView: 1,
  grabCursor: true,
  effect: "creative",
  creativeEffect: {
    prev: {
      shadow: true,
      translate: ["-20%", 0, -1],
    },
    next: {
      translate: ["100%", 0, 0],
    },
  },
  autoplay: {
      delay: 6000
  },
  speed: 1600,
  loop: true,
});